import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Modal from 'react-modal'
import _ from 'lodash'

import AccommodationsList from './elements/AccommodationsList'
import ItineraryItem from './elements/ItineraryItem'
import { isRailBookers } from '../../configuration/brand'
import { getRAQFormUrl } from '../../configuration/deeplinking'
import loadShare from '../../configuration/loadShare'
import { formatItineraryDestinationsForDisplay } from '../../utilities/content/tours'
import { getDisplayBookButtons } from '../../redux/reducers/configuration';
import { stripHtml } from '../../utilities/content/html'

import '../../styles/scss/elements/tour-itinerary.scss'

const TripItinerary = props => {
  const {
    containerClasses,
    description,
    destinationStart,
    destinationEnd,
    itinerary,
    map,
    reverseItinerary,
    isCityBreak,
    isGetaway,
    isRoundtrip,
    name,
    softripBooking,
    tourAccommodations,
    tripItineraryIsEmpty,
  } = props

  const [expandedItineraryItemKey, setExpandedItineraryItemKey] = useState(null)
  const [mapExpanded, setMapExpanded] = useState(false)
  const [shareOpen, setShareOpen] = useState(false)
  const [shareLoaded, setShareLoaded] = useState(false);
  const [windowOffset, setWindowOffset] = useState(0)

  const displayBookButtons = useSelector(getDisplayBookButtons)

  useEffect(() => {
    loadShare(() => {
      setShareLoaded(true);
    })
  })
  useEffect(()=>{
    if (!expandedItineraryItemKey) return
    
    const itineraryItemId = `itinerary-item-${expandedItineraryItemKey}`
    const stickyMenu = document.getElementById("tour-details-container__actions")
    const tourItineraryList = document.getElementById('tour-itinerary__list')
    const itineraryItem = document.getElementById(itineraryItemId)

    if (stickyMenu && tourItineraryList && itineraryItem) {
      const isSticky = stickyMenu.classList.contains("sticky")
      if (isSticky) {
        tourItineraryList.scrollIntoView()
        const topOffset = stickyMenu.getBoundingClientRect().bottom
        itineraryItem.style.scrollMarginTop = `${topOffset}px`
        itineraryItem.scrollIntoView()
        itineraryItem.style.scrollMarginTop = 0
      } else {
        const xPos = window.scrollX
        const yPos = window.scrollY      
        itineraryItem.scrollIntoView()
        window.scrollTo(xPos, yPos)
      }
    }
  },[expandedItineraryItemKey])

  if(shareLoaded && window.__sharethis__) {
    window.__sharethis__.initialize()
  }

  const mapClass = mapExpanded ? 'full-screen' : 'half'
  const mapButtonText = mapExpanded ? 'View Full Itinerary' : 'View The Full Map'
  const reverseItineraryText = reverseItinerary ? 'View Reverse' : 'Request Reverse'
  const reverseItineraryUrl = reverseItinerary || getRAQFormUrl(true)

  let extraClasses = isGetaway ? "getaway" : "not-getaway"
  extraClasses += mapExpanded ? " map-expanded" : " map-minimized"
  extraClasses += containerClasses ? ` ${containerClasses}` : ''

  const isRailBookersRoundTrip = isRailBookers() && (destinationStart === destinationEnd)
  const showDirections = !isCityBreak && !isGetaway && !isRoundtrip && !softripBooking && !isRailBookersRoundTrip
  const showItinerary = !isGetaway && !softripBooking && !tripItineraryIsEmpty

  const showFullMapViewToggle = showDirections
  const itinerarySectionTitle = showItinerary
    ? isRailBookers()
      ? <span>Itinerary</span>
      : <span>Trip <strong>Itinerary</strong></span>
    : name

  function toggleShareModal() {
    if (shareOpen) {
      document.body.setAttribute('style', '')
      window.scrollTo(0, windowOffset)
    } else {
      document.body.setAttribute('style', `overflow: hidden;`)
      setWindowOffset(window.scrollY)
    }
    setShareOpen(!shareOpen)
  }

  function onExpandItineraryItem(key) {
    setExpandedItineraryItemKey((value) => (value === key ? null : key))
  }

  return (
    <div className={`tour-itinerary ${extraClasses}`}>
        <div id="tour-itinerary" className={`tour-itinerary__content ${mapExpanded ? 'collapsed' : ''}`}>
            <div className='tour-itinerary__content__actions'>
              <button
                className="tour-itinerary__content__actions__share"
                onClick={toggleShareModal}
              >
                  Share Itinerary
              </button>
              {shareOpen && (
                <Modal
                  parentSelector={() =>
                    document.getElementById('ylg-ms__listings-details')
                  }
                  isOpen={shareOpen}
                  onRequestClose={toggleShareModal}
                  contentLabel="Available Dates"
                  style={{
                    overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 },
                    content: {
                      border: 'none',
                      height: 235,
                      margin: 'auto',
                      maxWidth: 600,
                      padding: 0,
                      zIndex: 9999,
                    },
                  }}
                >
                  <div className="tour-itinerary__content__actions__share-box">
                    <div className="tour-itinerary__content__actions__share-box__content">
                      <h4>Share your itinerary</h4>
                      <div className="sharethis-inline-share-buttons"></div>
                      <button className="tour-itinerary__content__actions__share-box__content__close" onClick={toggleShareModal} />
                    </div>
                  </div>
                </Modal>
              )}
              <button className="tour-itinerary__content__actions__print" onClick={() => window.print()}>Print Itinerary</button>
            </div>
            <h4>{itinerarySectionTitle}</h4>
            {!!description && <p className="description">{stripHtml(description.replaceAll(/\s/g,' '))}</p>}
            {showDirections && (
                <div className="tour-itinerary__direction">
                    <span className="tour-itinerary__direction__labels">
                        <span className="tour-itinerary__direction__label">Direction:</span>
                        <span className="tour-itinerary__direction__destinations">{destinationStart} → {destinationEnd}</span>
                    </span>
                    {displayBookButtons && (
                      <a
                        className="tour-itinerary__direction__button"
                        href={reverseItineraryUrl}
                      >
                        {reverseItineraryText}
                      </a>
                    )}
                </div>
            )}
            {showItinerary && (
              <div id="tour-itinerary__list" className="tour-itinerary__list">
                  {_.map(itinerary, (item, key) => {
                    const featuredImage = _.get(item, 'featuredImage') || _.get(item, 'itineraryImage')
                      return (
                        <ItineraryItem
                            key={key}
                            itemIndex={key}
                            accommodations={item.accommodations}
                            day={item.day}
                            description={item.description}
                            destinations={item.destinations}
                            image={featuredImage}
                            isExpanded={key === expandedItineraryItemKey}
                            onExpand={() => onExpandItineraryItem(key)}
                            title={item.heading || formatItineraryDestinationsForDisplay(_.get(item, 'destinations', []))}
                            showDays={_.size(itinerary) > 1}
                            isGetaway={isGetaway}
                        />
                      )
                  })}
              </div>
            )}
            {!showItinerary && !_.isEmpty(tourAccommodations) && (
              <AccommodationsList accommodations={tourAccommodations} />
            )}
        </div>
        {map && (
          <div className={`tour-itinerary__map ${mapClass}`}>
            {showFullMapViewToggle && (
              <button className='tour-itinerary__map__button' onClick={() => setMapExpanded(!mapExpanded)}>{mapButtonText}</button>
            )}
            <img alt="" src={map} />
          </div>
        )}
    </div>
  )
}

export default TripItinerary